<template>
    <v-card
      class="mx-auto my-12"
      max-width="390">

      <div v-if="isPaymentSuccessful">
        <v-img
          class="white--text align-end mb-6"
          src="../assets/ASN Transfers_500x141.png">
        </v-img>

        <template slot="progress">
          <v-progress-linear
            color="deep-purple"
            height="10"
            indeterminate></v-progress-linear>
        </template>

        <div class="mx-auto confirmation">
          <LoadingSpinner :isComplete="isComplete"></LoadingSpinner>
        </div>

        <v-alert
          dense
          outlined
          type="success">Booking saved successfully.</v-alert>

        <v-alert
          dense
          outlined
          :type="isPaymentSuccessful ? 'success' : 'error'">{{ paymentDescriptionText }}</v-alert>

        <v-card-text>
          <div v-if="paymentType === 1">
            Your payment reference number:
            <div class="title">{{ paymentReferenceNumber }}</div>
          </div>
        </v-card-text>

        <v-card-text>
          <div>
            Your booking number: <div class="title">{{ bookingNumber }}</div>
          </div>
        </v-card-text>

         <v-card-text>
          <div>
            Your fare: <div class="title">{{ fare | toCurrency }}</div>
          </div>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions>
          <v-container>
              <v-row>
                <v-col>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        Booking details
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <itinerary :showDisclaimer="false"></itinerary>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-card-title>Invoice</v-card-title>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <PrintInvoiceButton
                      :headerImageSrc="require('@/assets/ASNTransfers-100x28.jpg')">
                  </PrintInvoiceButton>
                </v-col>
                <v-col v-if="IS_ADMINISTRATOR">
                  <v-btn block class="text-center offset-md-1" @click="copyInvoice()">
                    <v-icon left>mdi-content-copy</v-icon>Copy
                  </v-btn>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-4">
                <v-col>
                  <v-btn block class="text-center" @click="back()">
                    Back
                  </v-btn>
                </v-col>
              </v-row>
          </v-container>
        </v-card-actions>
      </div>
      <div v-if="!isPaymentSuccessful">
        <div class="payment-response__failure text-center title">
          <div>Payment failed.</div>
        </div>
      </div>
    </v-card>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import Itinerary from '@/components/Itinerary.vue';
import PrintInvoiceButton from '@/components/PrintInvoiceButton.vue';
import storeConstants from '@/store/storeConstants';

export default {
  name: 'confirmation',
  components: {
    LoadingSpinner,
    PrintInvoiceButton,
    Itinerary,
  },
  data: () => ({
    isComplete: false,
  }),
  computed: {
    ...mapGetters([storeConstants.IS_ADMINISTRATOR,
      'BOOKING',
      'CONFIGURATION']),
    // The `mapFields` function takes an array of
    // field names and generates corresponding
    // computed properties with getter and setter
    // functions for accessing the Vuex store.
    ...mapFields([
      'booking.bookingNumber',
      'booking.paymentReferenceNumber',
      'booking.paymentDescriptionText',
      'booking.paymentType',
      'booking.isPaymentSuccessful',
      'booking.fare',
      'booking.bookingMessageContent',
    ]),
  },
  mounted() {
    // if no booking number found in store, redirect back to booking page.
    if (!this.bookingNumber) {
      this.$router.push({ name: 'booking' });
    }

    this.SET_LOADING(false);
    this.SET_SHOW_FARE(false);
    setTimeout(() => {
      this.isComplete = true;
    }, 750);
  },
  methods: {
    ...mapMutations(['SET_LOADING',
      'SET_SHOW_FARE']),
    back() {
      this.$router.push({ name: 'booking' });
    },
    copyInvoice() {
      navigator.clipboard.writeText(this.bookingMessageContent);
      this.$store.commit(storeConstants.SET_SNACKBAR_TEXT, 'Booking invoice copied to clipboard.');
      this.$store.commit(storeConstants.SET_DISPLAY_SNACKBAR, true);
    },
  },
};
</script>

<style scoped>
.payment-response__failure {
  top: -1rem;
  color: #ff0000;
}
.payment-response__success {
  top: -1rem;
  color: #287428;
}
.confirmation {
  width: 110px;
}
.v-card__text {
  padding: 1rem;
}
.v-card__title
{
  font-size: 1rem;
}
</style>
